export default "__VITE_ASSET__ab30d62e__"